import { INIT_NO_OP_NUM, REPORT_FILE_TYPE } from '@/config';

const state = {
  id: INIT_NO_OP_NUM,
  specialty: null,
};

const getters = {
  getProviderId: state => state.id,
  getProviderSpecialty: state => state.specialty,

};

const mutations = {
  setProvider (state, payload) {
    state.id = parseInt(payload.id);
    state.specialty = payload.specialty;
  },
  clearProvider (state) {
    state.id = INIT_NO_OP_NUM
    state.specialty = null;
  }
  
};

const actions = {
  updateCurrentProvider({commit}, provider) {
    commit('setProvider', provider);
  },
  clearProvider({commit}) {
    commit('clearProvider');
  }
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
